import { render, staticRenderFns } from "./transactionComplainForm.vue?vue&type=template&id=33b9e58e"
import script from "./transactionComplainForm.vue?vue&type=script&lang=js"
export * from "./transactionComplainForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports